module.exports = __webpack_public_path__ + "website/img/618Icon2.13fc1c0d.svg";